import { useAppStateStore } from "@/store/appState.js"
import { useConfigurationStore } from "@/store/configuration.js"

import { cookiesRestrictionLevels } from "@/constants/cookiesRestrictions.js"

const userSessionKey = "userSession"

export const storageOverride = {
  getItem(key) {
    //It does it before configuration fetch, but the data shouldn't be there if not stored before
    if (this.isKeyAllowed(key)) {
      return window.localStorage.getItem(key)
    }
    return null
  },
  setItem(key, value) {
    if (this.isKeyAllowed(key)) {
      window.localStorage.setItem(key, value)
    } else {
      window.localStorage.removeItem(key)
    }
  },
  isKeyAllowed(key) {
    const appStateStore = useAppStateStore()
    const configurationStore = useConfigurationStore()
    return (
      !configurationStore.configuration.cookiesStrictMode ||
      appStateStore.cookiesRestrictionLevel === cookiesRestrictionLevels.allow_all ||
      key === userSessionKey
    )
  }
}
